
export default function useIO ($store, service = 'Directr') {
  const $service = $store.getters[`Services/${service}`]

  function listen (event, callback) {
    $service.listen(event, callback)
  }

  function parseUpdate (payload) {
    return 'update'
  }
  function parseError (payload) {
    return 'info'
  }
  function parseInfo (payload) {
    return 'info'
  }

  return {
    listen,
    parse: {
      update: parseUpdate,
      error: parseError,
      info: parseInfo
    }
  }
}
